import { Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './components/dashboard/Home';

import ProtectedRoute from './helpers/ProtectedRoute';
import PublicOnlyRoute from './helpers/PublicOnlyRoute';

import AdminLayout from './components/admin/AdminLayout';
import ContentsList from './components/admin/Views/Contents/ContentsList';
import SeriesList from './components/admin/Views/Series/SeriesList';
import AddSeries from './components/admin/Views/Series/AddSeries';
import AddContents from './components/admin/Views/Contents/AddContents';
import Categories from './components/admin/Views/Categories/Categories';
import Media from './components/admin/Views/Media/Media';
import Users from './components/admin/Views/Users/Users';
import Dashboard from './components/admin/Views/Dashboard';
import Login from './auth/Login';
import AuthorsManager from './components/admin/Views/Authors/AuthorsManager';
import TagsManager from './components/admin/Views/Tags/TagsManager';
import AdminErrors from './components/admin/Views/Errors/Errors';
import Notifications from './components/admin/Views/Notifications/Notifications';
import PromoCodes from './components/admin/Views/PromoCodes.tsx/PromoCodes';
import Rate from './components/admin/Views/Rate/Rate';
import Register from './auth/Register';
import ForgotPassword from './auth/ForgotPassword';
import ResetPassword from './auth/ResetPassword';
import EmailVerified from './auth/EmailVerified';
import MediaPublicDetail from './components/admin/Views/Media/MediaPublicDetail';
import LegalManager from './components/admin/Views/Legal/LegalManager';
import LegalPublic from './auth/LegalPublic';
import WelcomeSplash from './components/admin/WelcomeSplash';
import GenerateAudio from './components/admin/Views/Media/GenerateAudio';
import VocabCardList from './components/admin/Views/VocabCards/VocabCardList';
import VocabCard from './components/admin/Views/VocabCards/VocabCard';

export default function App() {
	return (
		<Routes>
			<Route path="/" element={<Layout />}>
				<Route index element={<Home />} />

				{/* Publiczne strony niezależne od panelu admin: */}
				<Route path="password/reset" element={<ResetPassword />} />
				<Route path="auth/verified" element={<EmailVerified />} />
				<Route path="polityka-prywatnosci" element={<LegalPublic />} />
				<Route path="polityka-prywatnosci/en" element={<LegalPublic />} />
				<Route path="regulamin" element={<LegalPublic />} />
				<Route path="regulamin/en" element={<LegalPublic />} />

				<Route path="admin">
					<Route element={<PublicOnlyRoute />}>
						<Route path="login" element={<Login />} />
						<Route path="register" element={<Register />} />
						<Route path="password/forgot" element={<ForgotPassword />} />
					</Route>

					{/* PROTECTED: cała reszta /admin */}
					<Route element={<ProtectedRoute />}>
						<Route path="welcome" element={<WelcomeSplash />} />

						<Route element={<AdminLayout />}>
							<Route path="vocab-cards" element={<VocabCardList />} />
							<Route path="vocab-cards/new" element={<VocabCard />} />
							<Route path="vocab-cards/edit/:id" element={<VocabCard />} />
							<Route index element={<Dashboard />} />
							<Route path="authors" element={<AuthorsManager />} />
							<Route path="tags" element={<TagsManager />} />
							<Route path="media" element={<Media />} />
							<Route path="media/:id" element={<MediaPublicDetail />} />
							<Route path="users" element={<Users />} />
							<Route path="promocodes" element={<PromoCodes />} />
							<Route path="notifications" element={<Notifications />} />
							<Route path="errors" element={<AdminErrors />} />
							<Route path="rules" element={<LegalManager />} />
							<Route path="rate" element={<Rate />} />
							<Route path="generate-audio" element={<GenerateAudio />} />
							<Route path="contents">
								<Route index element={<ContentsList />} />
								<Route path="new" element={<AddContents />} />
								<Route path="edit/:id" element={<AddContents />} />
							</Route>
							<Route path="series">
								<Route index element={<SeriesList />} />
								<Route path="new" element={<AddSeries />} />
								<Route path="edit/:id" element={<AddSeries />} />
							</Route>
							<Route path="categories" element={<Categories />} />
						</Route>
					</Route>
				</Route>
			</Route>
		</Routes>
	);
}
